module.exports = __webpack_public_path__ + "static/media/logo-secAI.99bf92ae.png";